module.exports = __webpack_public_path__ + "static/media/whitelogo.5c2b21d5.png";